<template>
    <div>
        <div class="model-list">
            <!-- 根据radio-name对应的字段和show-value里指定的值来决定input框是否显示，实现的功能就是iput框根据radio选项来决定是否显示 -->
            <component :is="`tms-type-${f.type}`" v-for="f in field.content" :field="f" :key="f.key" :config="config[field.key]" v-if="config[field.key][field['radio-name']] === field['show-value'] || f.key === field['radio-name']"></component>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

    export default {
        name: 'tms-type-radio-box-input',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            config: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },

        components: {
        },

        mounted() {
        },

        methods: {}
    }

</script>
